import config from './config'

export const OrgAPI = {
    getBrandKit: () => {
        return config.get('/api/organization/brand_kit/')
    },

    updateOrgProfile: ({ name, description }) => {
        return config.post('/api/organization/profile/', {
            name,
            description,
            is_onboarded: true,
        })
    },
}
